<template>
 <div>
   <div class="formBox margbot" ref="searchBox">
      <el-form :inline="true"  class="demo-form-inline" label-width="110px" size="mini">
         <!-- <div class="searchBox inpBox"> -->
          <div class="formItemBox">
        <el-form-item label="所在仓库:" prop="organizationId">
              <el-select  v-model="searchFrom.organizationId"  placeholder="">
                <el-option v-for="val in warehouseList" :label="val.relTenantName" :value="val.relTenantCode" :key="val.relTenantCode"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="货物类型:" prop="productType">
              <el-select  v-model="searchFrom.productType"   placeholder="请选择">
                <el-option v-for="item in productTypes" :label="item.show_name" :value="item.item_no" :key="item.item_no"></el-option>
              </el-select>
            </el-form-item>
              <el-form-item label="货权方:" prop="ownerCustomerName" v-if="tableArr[1]">
              <el-input  placeholder="" v-model="searchFrom.ownerCustomerName"></el-input>
            </el-form-item>
            <el-form-item label="控货方:" prop="oldPrimaryCustomerName" v-if="tableArr[0]">
              <el-input  placeholder="" v-model="searchFrom.oldPrimaryCustomerName"></el-input>
            </el-form-item>
              <el-form-item label="原客户名称:" prop="oldSecondaryCustomerName">
              <el-input  placeholder="" v-model="searchFrom.oldSecondaryCustomerName"></el-input>
            </el-form-item>
            <el-form-item label="现一级客户名称:" prop="newPrimaryCustomerName">
              <el-input  placeholder="" v-model="searchFrom.newPrimaryCustomerName"></el-input>
            </el-form-item>
              <el-form-item label="现二级客户名称:" prop="newCustomerName">
              <el-input  placeholder="" v-model="searchFrom.newCustomerName"></el-input>
            </el-form-item>
            <el-form-item label="产地:" prop="steelMillName">
              <el-input  placeholder="" v-model="searchFrom.steelMillName"></el-input>
            </el-form-item>
              <el-form-item label="规格:" prop="specification">
              <el-input  placeholder="" v-model="searchFrom.specification"></el-input>
            </el-form-item>
              <el-form-item label="材质:" prop="model">
              <el-input  placeholder="" v-model="searchFrom.model"></el-input>
            </el-form-item>
              <el-form-item label="审核状态:" prop="changeStatus">
            <el-select v-model="searchFrom.changeStatus" placeholder="请选择">
                <el-option  label="全部" value="" ></el-option>
              <el-option  label="同意" value="1" ></el-option>
              <el-option  label="驳回" value="2" ></el-option>
            </el-select>
          </el-form-item>
            <!-- <el-form-item label="转货类型:" prop="changeStatus">
            <el-select v-model="searchFrom.changeStatus" placeholder="请选择">
                <el-option  label="全部" value="" ></el-option>
              <el-option  label="转货" value="1" ></el-option>
              <el-option  label="回购" value="2" ></el-option>
              <el-option  label="钢厂转货" value="2" ></el-option>
            </el-select>
          </el-form-item> -->
              <el-form-item label="转货时间:" prop="timecheacked">
              <el-date-picker
                v-model="timecheacked"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              ></el-date-picker>
            </el-form-item>
          </div>
        <!-- </div> -->
        <div class="searchBtnBox">
          <el-button type="primary" @click="searchFn">查询</el-button>
          <el-button type="primary"  @click="resetForm('searchFrom')">重置</el-button>
          <el-button type="primary"  @click="exportFn" :disabled="isDisable">导出</el-button>
          <el-form-item>
            <p class="margin0">总件数：<span class="red">{{tongji.allNumber}}</span>件</p>
          </el-form-item>
          <el-form-item>
            <p class="margin0">总重量：<span class="red">{{tongji.allWeight}}</span>吨</p>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList"  ref="table"   bordersize="mini"  @selection-change='selectGoods'
       @row-click="handleRowClick"  style="width: 100%" height="100%"  center border v-if="tableArr.length>0">
        <el-table-column type="index" prop="date" width="55" label="序号"></el-table-column>
          <!-- <el-table-column property="changeStatus" label="审核状态" >
          <template scope="scope">
            {{[ "通过", "驳回"][scope.row.changeStatus-1]}}
          </template>
        </el-table-column> -->
        <el-table-column prop="changeStatus"   label="审核状态"></el-table-column>
        <!-- <el-table-column prop="changeTypeName" :formatter="emptyFn"   label="转货类型"></el-table-column> -->
       <el-table-column prop="approverDate"  min-width="200" :formatter="dateTimeFormat" label="转货时间"></el-table-column>
       <el-table-column prop="oldOwnerCustomerName"  min-width="200" v-if="tableArr[1]" :formatter="emptyFn" label="货权方"></el-table-column>
      <el-table-column prop="oldPrimaryCustomerName"  min-width="200" v-if="tableArr[0]" :formatter="emptyFn" label="控货方"></el-table-column>
         <el-table-column prop="oldSecondaryCustomerName"  min-width="200" :formatter="emptyFn" label="原客户名称"></el-table-column>
         <el-table-column prop="newPrimaryCustomerName"  min-width="200" :formatter="emptyFn" label="现一级客户名称"></el-table-column>
       <el-table-column prop="newSecondaryCustomerName"  min-width="200" :formatter="emptyFn" label="现二级客户名称"></el-table-column>
         <el-table-column prop="productTypeName"  min-width="150" :formatter="emptyFn" label="货物类型"></el-table-column>
          <el-table-column prop="steelMillName"  width="150" :formatter="emptyFn" label="产地"></el-table-column>
          <el-table-column prop="specification"  min-width="200" :formatter="emptyFn" label="规格"></el-table-column>
        <el-table-column prop="model"  min-width="200" :formatter="emptyFn" label="材质"></el-table-column>
        <!-- <el-table-column prop="root"  width="150" :formatter="emptyFn" label="单件支数"></el-table-column>
        <el-table-column prop="length"  min-width="150" :formatter="emptyFn" label="长度(m)"></el-table-column> -->
        <el-table-column prop="number"  min-width="150" :formatter="emptyFn" label="总件数"></el-table-column>
        <el-table-column prop="allWeight"  width="150"  label="总重量(吨)"></el-table-column>
        <el-table-column prop="organizationName"  width="150" :formatter="emptyFn" label="所在仓库"></el-table-column>
         <el-table-column prop="plateNumber"  min-width="120" :formatter="emptyFn" label="车船号"></el-table-column>
         <el-table-column prop="shipForecastNo"  min-width="170" :formatter="emptyFn" label="预报编号"></el-table-column>
      </el-table>
    </div>
     <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[50,100,200,1000]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
 </div>
</template>

<script>
import { emptyFn, dateTimeFormat, dateFormat } from '@/utils/util'
import { getEmptyChangeRecordForHz, getEmptyChangeRecordForHzWN, selectCommonDictionary } from '@/api/soc-stock-cosco'
import { exportExcel } from '@/utils/fileDown.js'
import { getAttribute } from '@/utils/getButton'
export default {
  props: {
    productTypes: {
      type: Array,
      required: true
    },
    warehouseList: {
      type: Array,
      required: true
    }

  },
  data () {
    return {
      tableArr: [],
      timecheacked: '',
      h: 500,
      oneCustomerTaxId: localStorage.getItem('tenantTaxpayerNumber'),
      dateTimeFormat: dateTimeFormat,
      dateFormat: dateFormat,
      emptyFn: emptyFn,
      dialogVisible: false,
      tableList: [],
      searchFrom: {
        pageNo: 1,
        pageSize: 50
      },
      total: 0,
      loading: 'false',
      goodTypes: [],
      isDisable: false,
      tongji: {},
      btnFlg: [],
      btnIdArr: ['004P003B000', '004P003B001', '004P003B002']
    }
  },
  created () {
    this.searchFrom.oldHzCustomerTaxId = this.oneCustomerTaxId
    this.tableArr = getAttribute('ARRoneCustomerName,ARRownerCustomerName')
    if (this.warehouseList.length > 0) {
      this.$set(this.searchFrom, 'organizationId', this.warehouseList[0].relTenantCode)
    }
    this.getList()
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 215) + 'px'
  },
  methods: {
    // 导出
    exportFn () {
      let falg = this.tableArr[0]
      let form = { ...this.searchFrom }
      form.oneCustomerNameFlag = falg
      form.ownerCustomerNameFlag = this.tableArr[1]
      delete form.pageNo
      delete form.pageSize
      exportExcel(
        this.global.wmsStockName + '/tEmpty/exportEmptyChangeRecordListForHz',
        form,
        '转货记录'
      )
      this.isDisable = true
      setTimeout(() => {
        this.isDisable = false // 点击一次时隔两秒后才能再次点击
      }, 2000)
    },
    searchFn () {
      if (this.timecheacked) {
        this.searchFrom.dateStart = this.timecheacked[0]
        this.searchFrom.dateEnd = this.timecheacked[1]
      } else {
        this.searchFrom.dateStart = null
        this.searchFrom.dateEnd = null
      }
      this.getList()
    },
    // 选择数据
    selectGoods (selection) {

    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList () {
      this.loading = true
      getEmptyChangeRecordForHz(this.searchFrom).then(res => {
        this.loading = false
        // debugger
        this.tableList = res.list
        this.total = res.total
      })
      getEmptyChangeRecordForHzWN(this.searchFrom).then(res => {
        this.tongji = res
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList()
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList()
    },
    // 选择数据
    selectGoods (selection) {

    },
    // 重置
    resetForm (formName) {
      // debugger
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50,
        oldHzCustomerTaxId: this.oneCustomerTaxId,
        organizationId: this.warehouseList[0].relTenantCode
      }
      this.timecheacked = null
    },

    closeDialog () {
      this.addFrom = {}
      this.$refs.table.clearSelection()
      this.$refs.addFrom.clearValidate()
      this.flag = false
    }
  }
}
</script>

<style scoped lang='less'>
.searchBtnBox {
  margin-left: 10px;
  margin-bottom: 0;
  margin-top: 0;
}
.inpBox .el-date-editor{
  width: 350px!important;
}
.imgBox{
  display: flex;
  .item{
    display: flex;
     width: 50%;
     justify-content: space-around;
  }
}
/deep/ .checkboxBox{
  display: flex;
  label{
    flex-shrink: 0;
  }
  .el-checkbox-group{
    width:250px ;
  }
}
</style>
